<template>
  <div>
    <v-navigation-drawer app v-model="drawer">
      <template v-slot:prepend>
        <v-list-item two-line>
          <v-list-item-avatar>
            <v-img :src="ui.user.display_image"></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="title">{{
              ui.user.display_name
            }}</v-list-item-title>
            <v-list-item-subtitle>{{ ui.user.role }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon>mdi-menu-down</v-icon>
          </v-list-item-action>
        </v-list-item>
      </template>
      <v-list dense>
        <template v-if="ui.main_menu.groups">
          <template v-for="group in ui.main_menu.groups">
            <v-subheader
              class="mt-4 grey--text text--darken-1"
              :key="group.title"
              >{{ group.title }}</v-subheader
            >
            <v-list-item
              v-for="item in group.items"
              :key="item.name"
              :to="{
                name: 'entities_list',
                params: { type: item.action.entity_type }
              }"
            >
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.label }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </template>
        <template v-else>
          <template v-for="entity in ui.main_menu">
            <v-list-item
              :key="entity.name"
              :to="{ name: 'entities_list', params: { type: entity.type } }"
            >
              <v-list-item-action>
                <v-icon>{{ entity.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ entity.label }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </template>
      </v-list>
      <template v-slot:append>
        <v-card>
          <v-subheader>Версия: {{ $store.getters.appVersion }}</v-subheader>
        </v-card>
      </template>
    </v-navigation-drawer>
    <v-app-bar color="cyan" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer">
        <v-icon>menu</v-icon>
      </v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title>{{ $store.state.ui.title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu v-if="ui.languages">
        <template v-slot:activator="{ on }">
          <v-btn text icon v-on="on">
            <v-img :src="currentLangIcon" max-width="24"></v-img>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="lang in ui.languages"
            :key="lang"
            @click="chooseLang(lang)"
          >
            <v-list-item-avatar tile max-width="24" max-height="24">
              <v-img
                :src="langIcon(lang)"
                max-width="24"
                max-height="24"
              ></v-img>
            </v-list-item-avatar>
            <v-list-item-title>{{ langTitle(lang) }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn icon @click.stop="logout()">
        <v-icon>logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-content>
      <v-container fluid>
        <router-view></router-view>
        <Dialog
          v-if="dialog.result"
          :message="dialog.message"
          :show="true"
        ></Dialog>
      </v-container>
    </v-content>
    <v-footer app></v-footer>
  </div>
</template>

<script>
import auth from "./../api/auth";
import ui from "./../api/ui";
import Dialog from "./../components/Dialog";
import { mapState } from "vuex";
import db from "../api/db";

const languages = {
  ru: {
    title: "Русский",
    icon: "https://cdn.vuetifyjs.com/images/flags/ru.png"
  },
  en: {
    title: "English",
    icon: "https://cdn.vuetifyjs.com/images/flags/us.png"
  }
};

export default {
  components: { Dialog },
  data() {
    return {
      drawer: null,
      entities: [],
      dialog: this.$store.state.dialog
    };
  },

  computed: {
    ...mapState(["ui"]),
    currentLangIcon() {
      const lang = this.$store.getters.getLocale;
      return this.langIcon(lang);
    }
  },

  async created() {
    const result = await ui.get_ui(this.token); // Пытаемся получить информацию об UI с сервера
    console.log("RESULT", result);
    // Обновляем информацию об UI во Vuex, если удалось ее получить
    if (result) this.$store.commit("updateUI", result);
    // Если не удалось (токен пустой), то посылаем на страницу аутентификации
    else this.$router.push({ name: "login" });
  },

  methods: {
    langTitle(lang) {
      return languages[lang].title;
    },
    langIcon(lang) {
      return languages[lang].icon;
    },
    chooseLang(lang) {
      this.$store.commit("setLocale", lang);
      db.saveLocale(lang);
      this.$router.go();
    },
    async logout() {
      // TODO: Следующие 3 строки неразрывно связаны и являются внутренним API,
      // необходимо выделить его
      await auth.logout(this.token);
      await db.deleteToken();
      this.$store.commit("setToken", "");

      this.$router.push({ name: "login" });
    }
  }
};
</script>
